<template>
    <section class="page12">
        <div class="conteudo text-left">
            <div class="col1">
                <p
                    class="openSans text-huge text-bold text-white"
                    data-aos="flip-right"
                    data-aos-duration="1000"
                >
                    Quais as 6 etapas do plano estratégico para estar em compliance com a LGPD?
                </p>
            </div>
            <div class="col2"></div>
        </div>
    </section>
</template>

<script>
export default {
    data() {
        return {};
    },
    methods: {},
};
</script>

<style lang="scss" scoped>
.page12 {
    position: relative;
    background-image: url("~@/assets/img/section-bg.png");
    background-size: cover;
    background-repeat: no-repeat;
    background-position-x: right;
    height: 768px;
    .conteudo {
        height: 100%;
        .col2 {
            width: 556px;
        }
    }
    @media (max-width: 1366px) {
        .conteudo {
            .col2 {
                display: none;
            }
        }
    }
    @media (max-width: 900px) {
        .col1 {
            padding-right: 0;
        }
        .text-huge {
            font-size: 3rem;
        }
    }
}
</style> 